// components/ReplyEditorToggle.tsx
import React, { useState } from 'react';
import ReplyEditor from 'features/posts/replyEditor';

type Props = {
  depth: number;
  author: string;
  permlink: string;
  parent_author: string;
  parent_permlink: string;
  onNewError: (msg: string) => void;
  onSuccess: (reply: any) => void;
  IpfsAccount: any; 
  onLogin:Function;
  isVisible?:boolean,
  buttonText?: string;
  buttonClassName?: string;
};

const ReplyEditorToggle = ({
  depth,
  author,
  permlink,
  parent_author,
  parent_permlink,
  IpfsAccount,
  onNewError,
  onSuccess,
  onLogin,
  isVisible = false,
  buttonText = 'Reply',
  buttonClassName = 'btn reply-button',
}: Props) => {
  const [showEditor, setShowEditor] = useState(isVisible);

  const toggle = () => setShowEditor(!showEditor);

  return (
    <>
    {!isVisible && (
        <button type="button" className={`${buttonClassName} post-tools`} aria-label={buttonText} aria-expanded={showEditor} onClick={toggle}>
            <i className="fas fa-reply" aria-hidden="true" /> {buttonText}
        </button>
    )} 
    <div className="reply-editor-toggle mt-2">
        
        {showEditor && (
            <ReplyEditor
                depth={depth}
                author={author}
                permlink={permlink}
                parent_author={parent_author}
                parent_permlink={parent_permlink}
                onNewError={onNewError}
                IpfsAccount={IpfsAccount}
                onLogin={onLogin}
                onSuccess={(reply) => {
                    onSuccess(reply);
                    if (!isVisible) {
                        toggle(); 
                    } 
                }}
            />
        )}
    </div>
    </>
  );
};

export default ReplyEditorToggle;
